import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MailStateService } from '../../services/mail-state.service';
import { LoginService } from '../../../login/services/login.service';
import { LoginStateService } from '../../../login/services/login-state.service';

@Component({
  selector: 'app-mail-login',
  templateUrl: './mail-login.component.html',
  styleUrls: ['./mail-login.component.css']
})
export class MailLoginComponent implements OnInit {

  constructor(
    private router: Router,
    private mailStateService: MailStateService,
    private loginService: LoginService,
    private loginStateService: LoginStateService,
  ) {

    this.loginStateService.eventUserLoggedIn.subscribe(
      user => {
        this.mailStateService.user = user;
        if (this.mailStateService.condition === 'subscribe' || this.mailStateService.condition === 'unsubscribe') {
          if (!this.mailStateService.user) {
            this.router.navigate(['mail/login']);
            return;
          } else {
            this.mailStateService.setUserCondition();
          }
        }
      }
    );

    this.loginService.loggedInUser.subscribe(
      user => {
        if (user && !this.mailStateService.user) {
          this.mailStateService.user = user;
          this.mailStateService.setUserCondition();
          this.router.navigate(['']);
        }
      }
    );
  }

  ngOnInit() {
  }

  onLoggedIn() {
    this.mailStateService.reset();
  }

}
